// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
    margin: 0;
    padding: 0;
}
.page{
    /* height: 100vh; */
    /* background-color: #f1eef7; */
    display: flex;
    /* align-items: center; */
    justify-content: center;
}
.container{
    margin-top: 2rem;
    margin-bottom: 2rem;
    /* max-height: 300px; */
    width: 300px;
    border-radius: 10px;
    /* background-color: rgba(255, 255, 255, 0.74); */
    background-color: #f1eef7;
    padding-bottom: 1rem;
}
.heading{
    text-align: center;
    /* font-family: Arial, Helvetica, sans-serif; */
    margin-top: 1rem;
    /* font-weight: bold; */
    font-size: 16px;
}
.close-icon{
    margin-left: -25px;
    height: max-content;
    color: white;
    background-color: #51a886;
    border-radius: 4px;
}
.img-holder-cross{
    display: flex;
    margin: auto;
    margin-top: 10px;
    width: 160px;
    height: 140px;
    border-radius: 5px;
}
.img-holder{
    margin: auto;
    width: 160px;
    height: 150px;
    margin-top: 10px;
    border-radius: 5px;
}
.img{
    width: 160px;
    height: 140px;
    object-fit: cover;
    background-color: black;
}
.circleIcon {
    margin-bottom: -60%;
    margin-left: 37%;
    color: white !important;
}
#input[type="file"]{
    display: none;
}
#input1[type="file"]{
    display: none;
}
#input2[type="file"]{
    display: none;
}
.label{
    width: 100%;
    margin-top: 1rem;
    display: flex;
    justify-content: center;
}
.image-upload{
    margin: auto;
    width: 200px;
    height: 20px;
    background-color: rgb(30, 158, 41);
    color: white;
    border-radius: 10px;
    text-align: center;
    cursor: pointer;
}
.upload-action{
    margin-top: 1rem;
    margin-bottom: 1rem;
    margin-left: 3.4rem;
    /* margin-right: 3.2rem; */
}`, "",{"version":3,"sources":["webpack://./src/oemManagement/uploadImage.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,aAAa;IACb,yBAAyB;IACzB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,iDAAiD;IACjD,yBAAyB;IACzB,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,+CAA+C;IAC/C,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,kCAAkC;IAClC,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,0BAA0B;AAC9B","sourcesContent":["*{\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n.page{\r\n    /* height: 100vh; */\r\n    /* background-color: #f1eef7; */\r\n    display: flex;\r\n    /* align-items: center; */\r\n    justify-content: center;\r\n}\r\n.container{\r\n    margin-top: 2rem;\r\n    margin-bottom: 2rem;\r\n    /* max-height: 300px; */\r\n    width: 300px;\r\n    border-radius: 10px;\r\n    /* background-color: rgba(255, 255, 255, 0.74); */\r\n    background-color: #f1eef7;\r\n    padding-bottom: 1rem;\r\n}\r\n.heading{\r\n    text-align: center;\r\n    /* font-family: Arial, Helvetica, sans-serif; */\r\n    margin-top: 1rem;\r\n    /* font-weight: bold; */\r\n    font-size: 16px;\r\n}\r\n.close-icon{\r\n    margin-left: -25px;\r\n    height: max-content;\r\n    color: white;\r\n    background-color: #51a886;\r\n    border-radius: 4px;\r\n}\r\n.img-holder-cross{\r\n    display: flex;\r\n    margin: auto;\r\n    margin-top: 10px;\r\n    width: 160px;\r\n    height: 140px;\r\n    border-radius: 5px;\r\n}\r\n.img-holder{\r\n    margin: auto;\r\n    width: 160px;\r\n    height: 150px;\r\n    margin-top: 10px;\r\n    border-radius: 5px;\r\n}\r\n.img{\r\n    width: 160px;\r\n    height: 140px;\r\n    object-fit: cover;\r\n    background-color: black;\r\n}\r\n.circleIcon {\r\n    margin-bottom: -60%;\r\n    margin-left: 37%;\r\n    color: white !important;\r\n}\r\n#input[type=\"file\"]{\r\n    display: none;\r\n}\r\n#input1[type=\"file\"]{\r\n    display: none;\r\n}\r\n#input2[type=\"file\"]{\r\n    display: none;\r\n}\r\n.label{\r\n    width: 100%;\r\n    margin-top: 1rem;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.image-upload{\r\n    margin: auto;\r\n    width: 200px;\r\n    height: 20px;\r\n    background-color: rgb(30, 158, 41);\r\n    color: white;\r\n    border-radius: 10px;\r\n    text-align: center;\r\n    cursor: pointer;\r\n}\r\n.upload-action{\r\n    margin-top: 1rem;\r\n    margin-bottom: 1rem;\r\n    margin-left: 3.4rem;\r\n    /* margin-right: 3.2rem; */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
